// extracted by mini-css-extract-plugin
export default {"labelContainer":"styles_labelContainer__hsqc7","label":"styles_label__OmKq7"};